var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('destroy',{attrs:{"question":_vm.sub18n.question,"submit":_vm.sub18n.submit,"icon":"trash-alt","method":"delete","url":_vm.url},on:{"destroyed":_vm.destroyed}})}
var staticRenderFns = []

export { render, staticRenderFns }